<div class="main-page-content">
  <div class="main-page-content-block">



    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                  sortField="IsMonitored" [sortOrder]="-1"
                 >

          <ng-template pTemplate="caption">
            <div class="d-flex justify-content-end ">

              <div class="p-2 flex-fill"><h1 class="content-heading-font">Web Sites</h1></div>
              <div class="ml-auto">
                <button class="btn btn-primary " (click)="loadTable(null)" title="Refresh">
                  <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>
                &nbsp;
                <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
                  <i class="pi pi-filter-slash"></i>
                </button>
                &nbsp;
                <a class="btn btn-secondary" [routerLink]="['/developer/websitesrequests']">View Executing Requests</a>

              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="text-center " pSortableColumn="SiteId">
                Site ID
                <p-sortIcon field="SiteId"></p-sortIcon>
                <p-columnFilter type="numeric" field="SiteId" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="SiteName" class="text-start ">
                Web Site
                <p-sortIcon field="SiteName"></p-sortIcon>
                <p-columnFilter type="text" field="SiteName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="BuildDate" class="text-center">
                Version<p-sortIcon field="BuildDate"></p-sortIcon>
                <p-columnFilter type="date" field="BuildDate" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>

              <th pSortableColumn="StartTime" class="text-center" style="width:130px;">
                Process<p-sortIcon field="StartTime"></p-sortIcon>
                <p-columnFilter type="date" field="StartTime" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>

              <th pSortableColumn="RequestsExecuting_App" class="text-end">
                Requests Executing <p-sortIcon field="RequestsExecuting_App"></p-sortIcon>
                <p-columnFilter type="numeric" field="RequestsExecuting_App" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="RequestsInQueue_App" class="text-end">
                Requests Queued <p-sortIcon field="RequestsInQueue_App"></p-sortIcon>
                <p-columnFilter type="numeric" field="RequestsInQueue_App" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>

              <th pSortableColumn="StatusMessage" class="text-start">
                Status
                <p-sortIcon field="StatusMessage"></p-sortIcon>
                <p-columnFilter type="text" field="StatusMessage" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item >
            <tr>
              <th class="text-center">
                {{ item.SiteId }}
              </th>
              <td class="text-start text-nowrap ">
                <a href="#" [routerLink]="['/developer/websites/'+  item.SiteId ]">
                  {{ item.SiteName  }}
                </a>
                <span *ngIf="!item.IsMonitored" class="badge bg-info">Not Monitored</span>
                
              </td>
              <td class="text-center text-nowrap ">
                {{ item.Version }} from 
                <span title="{{ item.BuildDate | date: 'short' }}"> {{ getTimeFromNow(item.BuildDate) }}</span>
              </td>

              <td class="text-center text-nowrap ">
                {{ item.ProcessIDs }} at {{ item.PercentProcessorTime }}% {{formatByteSizeMB( item.WorkingMemoryMB) }} Msince
                <span title="{{ item.StartTime | date: 'short' }}"> {{ getTimeFromNow(item.StartTime) }}</span>
              </td>
              <td class="text-end " [ngClass]="{'text-danger': item.RequestsExecuting_App>50}">
                {{ item.RequestsExecuting_App }} ({{ item.RequestExecutingTime_App }}ms)
              </td>
              <td class="text-end " [ngClass]="{'text-danger': item.RequestsInQueue_App>10}">
                {{ item.RequestsInQueue_App }} ({{ item.RequestWaitTime_App }}ms)
              </td>
              <td class=" text-break text-truncate " style="max-width: 10vw;">
                {{ GetStatusText(item) }}
              </td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10">No items found.</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary " (click)="loadTable(null)" title="Refresh">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>
</div>



